module.exports = __webpack_public_path__ + "static/media/1-mobile.fe524ea1.webp";